import { Injectable } from "@angular/core";
import { BehaviorSubject, Subject } from "rxjs";

@Injectable()
export class FullScreenService {
    fullScreen = false;
    private _fullScreen = new Subject<boolean>();
    fullScreen$ = this._fullScreen.asObservable();

    _fullScreenState = new BehaviorSubject<boolean>(false);
    fullScreenState$ = this._fullScreenState.asObservable();

    toggleFullScreen() {
        this._fullScreen.next(!this.fullScreen);
        this._fullScreenState.next(!this.fullScreen);
    }

    informFullScreen(state) {
        this._fullScreenState.next(state);
    }
}
